var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Observer',{on:{"on-change":_vm.scrolledBottom}},[_c('div',{staticStyle:{"height":"1px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }